export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'reassignment' as const;

export const SHIFT_REASSIGNMENT_QUERY_TIMEOUT = 5000;

export const RECOMMENDATIONS_SHOW_LIMIT = 4;
